import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "symbol symbol-50px" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Examine")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardTable = _resolveComponent("CardTable")!

  return (_openBlock(), _createBlock(_component_CardTable, {
    name: "Car",
    endpoint: 'car?verifyState=WaitReviewVerify&',
    header: $setup.tableHeader,
    breadcrumbs: $setup.breadcrumbs,
    customProperties: $setup.customProperties,
    url: "verify",
    canCreate: false
  }, _createSlots({
    "cell-images": _withCtx(({ row }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "custom-image-box",
          style: _normalizeStyle(`background-image: url('${
            row.images[0]?.image ||
            'https://images.squarespace-cdn.com/content/v1/5e19e28bf39c41335c1b173a/1584112794493-IAR3NEGG7WF847KLWEDT/mystery+car.jpg'
          }')`)
        }, null, 4),
        false
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: 
            row.images[0]?.image ||
            'https://images.squarespace-cdn.com/content/v1/5e19e28bf39c41335c1b173a/1584112794493-IAR3NEGG7WF847KLWEDT/mystery+car.jpg'
          ,
              alt: "Car Image"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    "cell-details": _withCtx(({ row }) => [
      _createVNode(_component_router_link, {
        style: {"min-width":"114px"},
        class: "btn px-8 py-2 text-uppercase btn-primary",
        to: `verify/${row.id}`
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    _: 2
  }, [
    _renderList($setup.loopers, (item, i) => {
      return {
        name: `cell-${item}`,
        fn: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row[item] || '-'), 1)
        ])
      }
    })
  ]), 1032, ["header", "breadcrumbs", "customProperties"]))
}